import type { JsonValue } from '@carcheck/shared';

/**
 * AUT-542 — helpers for the `/config` forms that edit a stored value as a
 * raw copy (RULINGS 11): the form never narrows the record to the shape it
 * knows, so fields it does not show travel back untouched.
 */

export type RawRecord = Record<string, unknown>;

export const isRawRecord = (v: unknown): v is RawRecord =>
  typeof v === 'object' && v !== null && !Array.isArray(v);

/** The stored value as a list of records, or `null` when it is not one. */
export const asRawRecords = (value: JsonValue | null): RawRecord[] | null => {
  if (!Array.isArray(value)) return null;
  const out: RawRecord[] = [];
  for (const item of value) {
    if (!isRawRecord(item)) return null;
    out.push(item);
  }
  return out;
};

/**
 * Back to the wire type. Safe by construction: every value started as the
 * wire `JsonValue` and the forms only write strings, numbers, booleans and
 * string arrays into it.
 */
export const toJsonValue = (value: RawRecord | RawRecord[]): JsonValue => value as JsonValue;
